module.exports = __webpack_public_path__ + "images/emoji/violin.8a415848df1a5cb54f28.png";